import TrackingModal from '@components/layout/TrackingModal.vue';

const useBillTracking = (
    { modalOnly }: { modalOnly: boolean } = { modalOnly: false }
) => {
    const authStore = useAuthStore();
    const router = useRouter();
    return () => {
        const { open } = useModal({
            component: TrackingModal,
            modalAttrs: { zIndexFn: () => 9999999 },
        });
        if (authStore.loggedIn && !modalOnly) {
            router.push('/panel/reserves');
        } else {
            open();
        }
    };
};

export default useBillTracking;
